export default __webpack_public_path__ + "static/media/delete-icon-disabled.b09e9f45.svg";